module.exports = __webpack_public_path__ + "static/media/s4.aa1631d3.svg";